import React from 'react';
import { Section, SectionHeader } from '../ui/Section';
import { motion } from 'framer-motion';
import { BookOpen, Headphones, Layout, Zap, Download, Lightbulb } from 'lucide-react';
const items = [{
  icon: BookOpen,
  text: 'PDFs educativos'
}, {
  icon: Headphones,
  text: 'Versiones en audio'
}, {
  icon: Layout,
  text: 'Contenido estructurado'
}, {
  icon: Zap,
  text: 'Acceso inmediato'
}, {
  icon: Download,
  text: 'Formato digital'
}, {
  icon: Lightbulb,
  text: 'Aprendizaje e inspiración'
}];
export function IncludesSection() {
  return <Section background="white" data-id="element-61">
      <SectionHeader title="¿Qué incluye el pack?" subtitle="Todo lo que necesitas para una experiencia de aprendizaje inmersiva." data-id="element-62" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-63">
        {items.map((item, index) => <motion.div key={item.text} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="flex items-center p-6 bg-[#FAF8F5] rounded-lg border border-[#F0E6D8] hover:border-[#C9A227] transition-colors duration-300" data-id="element-64">
            <div className="p-3 bg-[#3D2314] rounded-full mr-4 text-[#C9A227]" data-id="element-65">
              <item.icon className="w-6 h-6" data-id="element-66" />
            </div>
            <span className="text-lg font-medium text-[#3D2314]" data-id="element-67">
              {item.text}
            </span>
          </motion.div>)}
      </div>
    </Section>;
}